// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gy-3";
export var downloadButton = "_gy-4";
export var fileContainer = "_gy-9 _gy-7";
export var fileContainerBase = "_gy-7";
export var fileContainerBaseSm = "_gy-a _gy-7";
export var fileContainerFixedHeight = "_gy-8 _gy-7";
export var fileContainerFixedHeightSm = "_gy-c _gy-a _gy-7";
export var fileContainerSm = "_gy-b _gy-a _gy-7";
export var fileInfo = "_gy-5";
export var fileInfoWidthRestricted = "_gy-6";
export var fileType = "_gy-1";
export var fileTypeName = "_gy-2";
export var fileTypeSm = "_gy-d _gy-1";
export var image = "_gy-0";
export var link = "_gy-f";
export var overflowEllipsis = "_gy-e";